import { useTranslations } from "next-intl";

const filtersData = [
  {
    label: "all",
    value: "all",
  },
  {
    label: "products",
    value: "products",
  },
];

export default function SearchFilter({ filterValue, setFilterValue }: any) {
  const t = useTranslations("SearchNav");

  return (
    <div className="flex flex-wrap items-center gap-3.5 bg-white px-10 pb-7.5 border-b border-gray-3">
      {filtersData.map((item) => (
        <button
          key={item?.value}
          onClick={() => setFilterValue(item?.value)}
          className={`inline-flex h-10 items-center justify-center rounded-lg border px-3.5 py-2.5 text-base font-medium ${
            filterValue === item?.value
              ? "border-blue bg-[#E1E8FF] text-blue"
              : "border-gray-5 bg-white text-dark hover:border-blue hover:bg-[#E1E8FF]"
          }`}
        >
          {t(item?.label)}
        </button>
      ))}
    </div>
  );
}
